{
  "batteryCharge": {
    "legendWithUnitLabel": "Charge de la batterie interne ({{unitLabel}})"
  },
  "batteryGraph": {
    "legend": "Tension d'entrée (V)"
  },
  "dailyVolumeWithUnitLabel": "Volume quotidien (k{{unitLabel}})",
  "linkTo": "Analytique",
  "title": "Analyse des appareils",
  "waterUsage": {
    "graph": {
      "legend": "Volume journalier"
    }
  }
}
